import { FC } from "react";
import LogoImages from "../../assets/images/logoSvg.svg";
import MobileOTPInput from "components/MobileOtpInput";
import styled from "@emotion/styled";
import { Col } from "antd";

const ConfirmOtpPage: FC = () => {
  return (
    <>
      <MainSection>
        <Col
          xs={{ span: 24 , offset: 0 }} 
          sm={{ span: 24, offset: 0 }}
          md={{ span: 12, offset: 6 }}
          lg={{ span: 6, offset: 9 }}
        ></Col>
        <ImageSection>
          <img
            src={LogoImages}
            alt="Logo"
            width="100%"
            height={131}
            loading="lazy"
          />
        </ImageSection>
        <SectionInput>
          <MobileOTPInput />
        </SectionInput>
      </MainSection>
    </>
  );
};

export default ConfirmOtpPage;

const MainSection = styled.div`
  width: 100%;
  position: relative;
  min-height: 100vh;
`;


const ImageSection = styled.div`
  margin-top: 100px;
`;

const SectionInput = styled.div`
  padding: 0 20px;
`;


